import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './PremiumPage.css';

function PremiumPage() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false); // 🆕 Nouvel état pour l'admin
  const [formData, setFormData] = useState({
    nom: '',
    prenom: '',
    username: '',
    image: null
  });

  useEffect(() => {
    // On récupère les données stockées par ta LoginPage
    const token = localStorage.getItem('token');
    const storedUsername = localStorage.getItem('username');
    const storedRole = localStorage.getItem('role'); // 🆕 On récupère le rôle
    
    if (token) {
      setIsLoggedIn(true);
      setFormData(prevState => ({
        ...prevState,
        username: storedUsername || '' 
      }));

      // 🆕 Si le rôle est admin, on met à jour l'état
      if (storedRole === 'admin') {
        setIsAdmin(true);
      }
    } else {
      setIsLoggedIn(false);
      setIsAdmin(false); // Sécurité supplémentaire
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleImageChange = (e) => {
    setFormData(prevState => ({
      ...prevState,
      image: e.target.files[0]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const data = new FormData();
    data.append('nom', formData.nom);
    data.append('prenom', formData.prenom);
    data.append('username', formData.username);
    data.append('image', formData.image);

    try {
      await axios.post("https://api.memofacdz.com/api/premium/request", data, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      alert('Demande envoyée avec succès !');
    } catch (error) {
      console.error(error);
      alert('Erreur lors de l\'envoi');
    }
  };

  return (
    <div className="premium-page-container">
      <div className="glass-card premium-card">
        
        {/* 🆕 Bouton réservé à l'Admin */}
        {isAdmin && (
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <button 
              onClick={() => window.location.href = '/admin-premium'} // Remplace par ta route Admin
              className="submit-btn"
              style={{ 
                backgroundColor: '#343a40', 
                color: '#fff', 
                border: 'none', 
                padding: '10px 20px', 
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: 'bold',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              ⚙️ Gérer les accès premium
            </button>
          </div>
        )}
                {isAdmin && (
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <button 
              onClick={() => window.location.href = '/addmemoire-premium'} // Remplace par ta route Admin
              className="submit-btn"
              style={{ 
                backgroundColor: '#343a40', 
                color: '#fff', 
                border: 'none', 
                padding: '10px 20px', 
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: 'bold',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              ⚙️ Gérer les mémoires premium
            </button>
          </div>
        )}

        <h1 className="premium-title">Espace Premium</h1>
        
        {/* Informations de paiement */}
        <div className="account-info">
          <p><strong>CCP :</strong> 0029015592 cle 66</p>
          <p><strong>RIP :</strong> 00799999002901559266</p>
          <p><strong>TARIF :</strong> 500 DZD</p>
        </div>
        
 <div className="premium-divider"></div>

        {/* Condition d'affichage */}
        {isLoggedIn ? (
          /* Vérification de l'attribut Premium OU du rôle Admin */
          (localStorage.getItem("role") === "user-premium" || localStorage.getItem("role") === "admin") ? (
            
            /* --- SI CONNECTÉ ET PREMIUM (OU ADMIN) --- */
            <div className="premium-access-granted" style={{ textAlign: 'center', padding: '30px 10px' }}>
              <h3 style={{ color: '#ffc107', marginBottom: '15px' }}>
                {localStorage.getItem("role") === "admin" 
                  ? '👑 Accès Administrateur' 
                  : '🎉 Vous êtes membre Premium !'}
              </h3>
              <p style={{ marginBottom: '20px', color: '#02050b' }}>
                {localStorage.getItem("role") === "admin"
                  ? 'En tant qu\'administrateur, vous avez un accès total à la collection exclusive.'
                  : 'Votre compte est activé. Vous avez un accès illimité à notre collection exclusive.'}
              </p>
              <button 
                onClick={() => window.location.href = '/memoire-premium'} // ou navigate('/memoire-premium')
                className="submit-btn premium-btn"
                style={{ backgroundColor: '#ffc107', color: '#000', fontWeight: 'bold', maxWidth: '300px', margin: '0 auto' }}
              >
                Accéder aux contenus Premium
              </button>
            </div>

          ) : (
            
            /* --- SI CONNECTÉ MAIS PAS PREMIUM NI ADMIN (Affichage du formulaire) --- */
            <>
              <p className="premium-details">
                Veuillez remplir ce formulaire et joindre la preuve de paiement pour activer votre compte premium.
              </p>

              {/* Formulaire */}
              <form className="premium-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="nom">Nom</label>
                  <input 
                    type="text" 
                    id="nom" 
                    name="nom" 
                    value={formData.nom} 
                    onChange={handleChange} 
                    required 
                    placeholder="Entrez votre nom"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="prenom">Prénom</label>
                  <input 
                    type="text" 
                    id="prenom" 
                    name="prenom" 
                    value={formData.prenom} 
                    onChange={handleChange} 
                    required 
                    placeholder="Entrez votre prénom"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="username">Nom d'utilisateur</label>
                  <input 
                    type="text" 
                    id="username" 
                    name="username" 
                    value={formData.username} 
                    onChange={handleChange} 
                    required 
                    disabled 
                    className="disabled-input" 
                  />
                </div>

                <div className="form-group file-input-group">
                  <label htmlFor="image">Reçu de paiement (Image)</label>
                  <input 
                    type="file" 
                    id="image" 
                    name="image" 
                    accept="image/*" 
                    onChange={handleImageChange} 
                    required 
                  />
                </div>

                <button type="submit" className="submit-btn premium-btn">Soumettre la demande</button>
              </form>
            </>
          )
        ) : (
          /* --- SI NON CONNECTÉ --- */
          <div className="premium-login-warning" style={{ textAlign: 'center', padding: '20px' }}>
            <p style={{ color: '#ff4d4d', marginBottom: '20px', fontWeight: 'bold' }}>
              ⚠️ Vous devez être connecté pour demander un accès Premium.
            </p>
            <button 
              onClick={() => window.location.href = '/login'} 
              className="submit-btn premium-btn"
              style={{ maxWidth: '250px', margin: '0 auto' }}
            >
              Se connecter à mon compte
            </button>
          </div>
        )}
        
      </div>
    </div>
  );
}

export default PremiumPage;